// extracted by mini-css-extract-plugin
module.exports = {"root":"vOVID","imageWrapper":"MaqR4","name":"VRave","quote":"IoRcz"};